import * as Yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const E164_VALIDATION_MESSAGE =
  "Enter a valid international phone number (e.g. +420601123456)";

export function normalizePhoneToE164(value: unknown): string | null {
  if (value == null) return null;
  let input = String(value)
    .trim()
    .replace(/[\s()-]/g, "");
  if (input === "") return null;

  if (input.startsWith("00")) {
    input = `+${input.slice(2)}`;
  } else if (!input.startsWith("+")) {
    input = `+${input}`;
  }

  const parsed = parsePhoneNumberFromString(input);
  if (!parsed || !parsed.isValid()) {
    return null;
  }

  return parsed.format("E.164");
}

export function isValidE164(value: unknown): boolean {
  return normalizePhoneToE164(value) !== null;
}

export function isValidE164OrEmpty(value: unknown): boolean {
  if (value == null || String(value).trim() === "") {
    return true;
  }
  return isValidE164(value);
}

export function yupPhoneE164Required(message = E164_VALIDATION_MESSAGE) {
  return Yup.string()
    .required("Phone is required")
    .test("e164", message, (value) => isValidE164(value));
}
